module.exports = __webpack_public_path__ + "static/media/wapp.82fe8f3a.png";